import { unauthenticatedSearch } from "@/generated/api/sdk.gen"
import type { SearchRequest } from "@/generated/api/types.gen"
import type { Api } from "@/platform/api/api"
import { body } from "@/platform/api/gateways/common"

export const searchGateway = (api: Api) => ({
  items: (request: SearchRequest, signal?: AbortSignal, page?: string) =>
    body(unauthenticatedSearch({ ...api.request({ signal }), body: request, query: page ? { page } : undefined })),
})

export type SearchGateway = ReturnType<typeof searchGateway>
